import styled from 'styled-components';
import { BLUE_RIBBON_300, DARK_VIOLET, GRAYSCALE_300, GRAYSCALE_400 } from '@styles/colors';
import { GIVONIC } from '@styles/fonts';

export const ActionButtonContainer = styled.div<{ $disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  width: 72px;
  transition: transform 0.2s ease;
  opacity: ${({ $disabled }) => ($disabled ? 0.45 : 1)};

  &:hover {
    transform: ${({ $disabled }) => ($disabled ? 'none' : 'translateY(-2px)')};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const IconContainer = styled.div<{ $disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border: 1px solid ${({ $disabled }) => ($disabled ? GRAYSCALE_300 : BLUE_RIBBON_300)};
  border-radius: 100%;
  background-color: white;
  margin-bottom: 4px;
`;

export const LabelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Label = styled.span<{ $disabled?: boolean }>`
  font-family: ${GIVONIC.semiBold};
  font-size: 14px;
  color: ${({ $disabled }) => ($disabled ? GRAYSCALE_400 : DARK_VIOLET)};
  text-align: center;
`;
